import { createDeviceHook } from './create-device-hook';

// Pre-created hooks for each device kind
export const useResidualCurrentDevice = createDeviceHook('ResidualCurrentDevice');
export const useResidualCurrentCircuitBreakerDevice = createDeviceHook('ResidualCurrentCircuitBreakerDevice');
export const useFinalCircuitProtectiveDevice = createDeviceHook('FinalCircuitProtectiveDevice');

// Re-export types for convenience
export type {
    DeviceActions,
    DeviceHookConfig,
    DeviceHookResult,
    DevicePatcher,
} from '../types/hook-types';

export {
    createDeviceHook,
};
